// eslint-disable-next-line no-useless-escape
export const isValidEmailFormat = (v: string) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v);
